/**
 * §10.4 Core Values — 8-card tone-tinted grid.
 */

import React from 'react'
import {
  Lightbulb, Eye, ShieldCheck, HeartHandshake, Lock, Layers,
  GraduationCap, Handshake, Sparkles,
} from 'lucide-react'
import { Container, Eyebrow, SectionHeading } from '@/components/landing/design-system'
import FeatureGrid from '../FeatureGrid'
import { VALUES } from '../data'

const ICONS = {
  Lightbulb, Eye, ShieldCheck, HeartHandshake, Lock, Layers, GraduationCap, Handshake, Sparkles,
}

export default function Values() {
  return (
    <section className="relative py-24 md:py-28">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/15 to-transparent" />
      <Container size="wide" className="flex flex-col gap-10">
        <div className="flex flex-col items-center text-center gap-5 max-w-3xl mx-auto">
          <Eyebrow tone="green">Core Values</Eyebrow>
          <SectionHeading align="center"
            title={<>Eight principles that{' '}<span className="bg-gradient-to-r from-brand-gold to-[#FFE17A] bg-clip-text text-transparent">shape every decision.</span></>}
            subtitle="How we build the product, how we run the company and how we serve our customers.  These aren&apos;t posters on the wall — they are how we ship."
          />
        </div>
        <FeatureGrid items={VALUES} icons={ICONS} cols={4} />
      </Container>
    </section>
  )
}
